import { TRUSTPILOT_IDS, TRUSTPILOT_SLIM_HEADER_TEMPLATE_ID, TRUSTPILOT_TEMPLATE_ID } from './constants';
import type { TrustBadgeType } from '../types';

export function getTrustPilotId(siteBranchId: number): string {
  return TRUSTPILOT_IDS[siteBranchId];
}

export function getTrustPilotTemplateId() {
  return TRUSTPILOT_TEMPLATE_ID;
}

export function getTrustPilotSlimHeaderId() {
  return TRUSTPILOT_SLIM_HEADER_TEMPLATE_ID;
}

function updateTrustPilotBadgeDisplayValue(hide: boolean) {
  const trustedShopBadge: TrustBadgeType = document.querySelector('[id^="tp_wrapper"]');

  if (trustedShopBadge?.style) {
    trustedShopBadge.style.display = hide ? 'none' : 'block';
  }
}

export function hideTrustPilotBadge(hide: boolean) {
  return updateTrustPilotBadgeDisplayValue(hide);
}
